import { amplifyClient } from "@root/utils/amplify-utils";
import { KBRow } from "@src/types/kb";

export async function generateRecipe(formData: FormData) {
  const response = await amplifyClient.queries.askBedrock({
    ingredients: [formData.get("ingredients")?.toString() || ""],
  });

  const res = JSON.parse(response.data?.body!);
  // test res.content[0].text
  if (!res) {
    throw new Error("No res found in response 2.");
  } else {
    if (!res.content) {
      throw new Error("No content found response 2, Response is " + JSON.stringify(res));
    }
  }
  const content = res.content[0].text;
  if (!content) {
    throw new Error("No content found 2.");
  }
  return content || "";
}


export async function fetchTopChunks(embeddings: any, topK = 3) {
  return performVectorSearch(embeddings, topK);
}

export async function generateDataTitan(formData: FormData) {
  const response = await amplifyClient.queries.askBedrockTitan({
    customContent: [formData.get("customContent")?.toString() || ""],
  });
  // console.log('response:', response);
  const res = JSON.parse(response.data?.body!);

  if (!res.embedding) {
    throw new Error("No embeddings found.");
  }

  const err = JSON.parse(response.data?.error!);
  if (err !== null) {
    throw new Error("Error in embeddings.");
  }

  const content = res.embedding;
  return content || "";
}

export async function generateResponse(formDataOriginal: string, formDataEmbeddings: Array<string>) {
  // const formDataOriginalValidated = validateClaudaInput1(formDataOriginal);
  // if (formDataOriginalValidated.length < 2) {
  //   throw new Error("No embeddings found.");
  // }
  // console.log('req final: ', req[0], " ", req[1], " ", req[2]);
  if (formDataEmbeddings.length < 1) {
    throw new Error("No embeddings found.");
  }
  if (formDataEmbeddings[0] === null) {
    throw new Error("No embeddings found.");
  }
  if (formDataEmbeddings[0] === "") {
    throw new Error("No embeddings, found empty string.");
  }
  const response = await amplifyClient.queries.askBedrock({
    ingredients: formDataEmbeddings,
  });
  // const response = {data: {body: "response"}};
  const res = JSON.parse(response.data?.body!);
  // test res.content[0].text
  console.log('response:', res);
  if (!res) {
    throw new Error("No res found in response 1.");
  } else {
    if (!res.content) {
      throw new Error("No content found in response 1, Response is " + JSON.stringify(res));
    }
  }
  const content = res.content[0].text;
  if (!content) {
    throw new Error("No content found 1.");
  }
  return content || "";
}

export async function generateDataTitanFromString(formData: string, const_string: string) {
  console.log('formData:', formData);
  console.log('const_string:', const_string);
  const response = await amplifyClient.queries.askBedrockTitan({
    customContent: [validateTitanInput(formData, const_string)],
  });
  // console.log('response:', response);
  const res = JSON.parse(response.data?.body!);
  if (!res.embedding) {
    throw new Error("No embeddings found.");
  }

  const err = JSON.parse(response.data?.error!);
  if (err !== null) {
    throw new Error("Error in embeddings.");
  }
  if ((res.embedding === null) || (res.embedding === "")) {
    throw new Error("No embeddings found in body.");
  }

  const content = res.embedding;
  return content || "";
}

function validateTitanInput(inputString: string, const_string: string) {
  let result = "";
  let parsedInput = null;
  let is_json = false;
  // Ensure the input is valid JSON
  try {
    parsedInput = JSON.parse(inputString);
    is_json = true;
  } catch (error) {
    console.log('inputString:', inputString);
    console.log('Warning:Input string is not valid JSON to analyzer2', error);
    console.log('Warning:Input string is empty to analyzer2', parsedInput);
    console.log('Warning:Input string is empty to analyzer2', inputString);
    console.log('Warning:Input string is empty to analyzer2', const_string);
    // throw new Error("Invalid JSON input string provided to analyzer, titan");
  }
  // // Check for required properties in the parsed JSON
  // if (!parsedInput?.Product || !Array.isArray(parsedInput?.Product) || parsedInput?.Product.length === 0) {
  //   // throw new Error("Input-T string must contain a non-empty Product array.");
  //   console.log('Warning:Input-T string must contain a non-empty Product array', parsedInput);
  // }

  // if (!parsedInput) {
  //   // throw new Error("Input string is empty to analyzer2.");
  //   console.log('Warning:Input string is empty to analyzer2', parsedInput);
  // }
  // if (!parsedInput.Product[0] || !parsedInput.Score || !parsedInput.Ingredients || !parsedInput.PrimaryKey || !parsedInput.Reviews) {
  //   // throw new Error("Input string must contain Product, Score, Ingredients, PrimaryKey, and Reviews.");
  //   console.log('Warning:Input string must contain Product, Score, Ingredients, PrimaryKey, and Reviews', parsedInput);
  // }
  // // This is temporary.
  // if (parsedInput?.Reviews) {
  //   delete parsedInput.Reviews;
  // }

  // // Check if Product[0] exists and delete suptaminsScore from the first Product object
  // if (parsedInput?.Product[0] && parsedInput?.Product[0].suptaminsScore) {
  //   delete parsedInput.Product[0].suptaminsScore;
  // }
  // if (!parsedInput?.Product[0]) {
  //   // throw new Error("Input string must contain Product.");
  //   console.log('Warning:Input string must contain Product', parsedInput);
  // }
  // result = JSON.stringify(parsedInput?.Product[0] + const_string);
  // result = JSON.stringify(const_string);
  result = ""
  if (is_json) {
    result = JSON.stringify(parsedInput?.Product[0] + const_string);
  } else {
    result = const_string;
  }
  // console.log('request:', result);
  return result;
}

function validateClaudaInput1(inputString1: string) {
  let result = [];
  let parsedInput = null;
  // Ensure the input is valid JSON
  try {
    parsedInput = JSON.parse(inputString1);
  } catch (error) {
    throw new Error("Invalid JSON input string provided to analyzer.");
  }
  // Check for required properties in the parsed JSON
  if (!parsedInput?.Product || !Array.isArray(parsedInput.Product) || parsedInput.Product.length === 0) {
    throw new Error("Input-C string must contain a non-empty Product array.");
  }

  if (!parsedInput) {
    throw new Error("Input string is empty to analyzer2.");
  }
  if (!parsedInput.PrimaryKey) {
    throw new Error("Input string must contain PrimaryKey.");
  }
  // This is temporary.
  if (parsedInput.Reviews) {
    delete parsedInput.Reviews;
  }
  if (!parsedInput.Product[0]) {
    throw new Error("Input string must contain Product.");
  }
  result = [JSON.stringify(parsedInput.Product[0]) + " " + JSON.stringify(parsedInput.Score) + " " + JSON.stringify(parsedInput.Ingredients) + " PrimaryKey: " + parsedInput.PrimaryKey, parsedInput.PrimaryKey];
  // console.log('request2:', result[0], " ", result[1]);
  return result;
}

function validateClaudaInput2(inputString2: Array<string>) {
  // Ensure the input is valid JSON
  // console.log('inputString2:', inputString2);
  if (inputString2.length < 1) {
    throw new Error("No embeddings found.");
  }
  return inputString2;
}

function toPgVectorLiteral(vec: number[]): string {
  return `{${vec.join(",")}}`;
}

/**
 * Ensure we have at least one non-empty context chunk
 * and trim the list to the N chunks we want to show Claude.
 *
 * @param chunks        Top-k chunks returned from the vector search
 * @param maxChunks     Safety cap (default 3)
 * @returns string[]    Cleaned array we can join into the prompt
 */
export function validateClaudeContext(
  chunks: Array<string>,
  maxChunks = 3
): Array<string> {
  if (!Array.isArray(chunks) || chunks.length === 0) {
    throw new Error("No context chunks provided.");
  }

  // Remove null/empty entries, trim whitespace, then take the first N
  const cleaned = chunks
    .map(c => (c ?? "").trim())
    .filter(c => c.length > 0)
    .slice(0, maxChunks);

  if (cleaned.length === 0) {
    throw new Error("Context chunks were empty after cleaning.");
  }

  return cleaned;
}

function cleanUpInput(inputString: string): string {
  if (!inputString) {
    throw new Error("Input string is empty for cleanup.");
  }
  const parts = inputString.split(" ");
  if (parts.length === 0) {
    throw new Error("Input string is empty for cleanup.");
  }
  const cleanedParts: string[] = [];
  const key = parts[0].toLowerCase();
  if (!key) {
    throw new Error("Invalid key: empty");
  }
  cleanedParts.push(key);

  if (parts.length === 1) {
    return cleanedParts.join(" ");
  }

  for (let i = 1; i < parts.length; i++) {
    if (parts[i].toLowerCase() === key) {
      // Ensure the key is not repeated consecutively or as the last element
      if (i === parts.length - 1) {
        throw new Error(`Invalid sequence: "${inputString}"`);
      }
    } else {
      // Add non-key parts directly
      cleanedParts.push(parts[i].toLowerCase());
    }
  }

  // Ensure the cleaned string doesn't start or end with the key alone
  if (
    cleanedParts[0] !== key ||
    cleanedParts[cleanedParts.length - 1] === key
  ) {
    throw new Error(`Invalid start or end: "${inputString}"`);
  }

  return cleanedParts.join(" ");
}

const validStructure = {
  "vitamin-b": ["b6", "b", "b12", "b2", "b3"],
  "vitamin-d": ["d", "d3"],
  "vitamin-e": ["e", "e12"],
  b: ["complex"],
  methyl: ["cobalamin"],
  "magnesium-bisglycinate": ["bisglycinate", "glycinate"],
  n: ["acetyl", "cysteine"],
  "n-acetyl-l-cysteine": [], // Single key, no additional values needed
  omega: ["3", "dha", "epa", "fatty", "acids"],
  fatty: ["acids"],
  multi: ["vitamin"],
  specialized: ["pro", "resolving", "mediators"], // Requires exact sequence for this one only
  // Single keys (standalone)
  folate: [], riboflavin: [], methylcobalamin: [], pyridoxine: [], niacinamide: [], biotin: [], thiamine: [],
  betaine: [], choline: [], nac: [], calcium: [], mchc: [], hydroxyapatite: [],
  d3: [], cholecalciferol: [], epa: [], dha: [], multivitamin: [], phytonutrient: [], spm: [], resolvins: [], berberine: [],
  magnesium: []
};

function validateUserInput(inputString: string) {
  return inputString;
}

export async function generateResultFromWix(args: string) {
  // some coherence check.
  if (args.length < 1) {
    throw new Error("No data from user input");
  }
  const jsonString = JSON.stringify({
    keyword: validateUserInput(args),
  });
  const response = await amplifyClient.queries.fetchDataFromWix({
    queryStringParameters: jsonString,
  });

  return response.data?.body || "";
}

export async function generateResultFromElfsight(args: string) {
  // some coherence check.
  if (args.length < 1) {
    throw new Error("No data from Elfsight input");
  }
  const response = await amplifyClient.queries.fetchDataFromElfsight({
    queryStringParameters: args,
  });
  return response || "";
}

export async function pushLogToCloudWatch(args: string) {
  // some coherence check.
  if (args.length < 1) {
    throw new Error("No data to push to cloudwatch");
  }
  const jsonString = JSON.stringify({
    sourceLog: args,
  });
  const response = await amplifyClient.mutations.logSource({
    queryStringParameters: jsonString,
  });

  return response || "";
}

// Add this new function to call the vectorSearch GraphQL operation
async function performVectorSearch(queryVector: any, topK = 3) {
  try {
    // Validate embeddings
    if (!queryVector) {
      throw new Error("No query vector provided to performVectorSearch");
    }
    if (queryVector.length === 0) {
      throw new Error("Query vector is empty");
    }

    // Check if queryVector is an array
    let embeddingVector: number[];

    if (Array.isArray(queryVector)) {
      embeddingVector = queryVector;
    } else if (typeof queryVector === 'object' && queryVector.embedding) {
      // Handle case where queryVector might be an object with an embedding property
      embeddingVector = queryVector.embedding;
    } else if (typeof queryVector === 'string') {
      // Try to parse if it's a string
      try {
        const parsed = JSON.parse(queryVector);
        embeddingVector = Array.isArray(parsed) ? parsed : parsed.embedding;
      } catch (e) {
        throw new Error("Invalid query vector format: could not parse string");
      }
    } else {
      throw new Error("Invalid query vector format: expected array or object with embedding property");
    }

    // Validate vector dimensions
    if (!Array.isArray(embeddingVector) || embeddingVector.length === 0) {
      throw new Error("Invalid embedding vector: empty or not an array");
    }

    // Validate topK
    if (typeof topK !== 'number' || topK < 1) {
      topK = 3; // Default to 3 if invalid
    }

    // Convert the vector to a string for the GraphQL API
    const queryVectorString = JSON.stringify(embeddingVector);

    console.log('Sending vector search request with topK:', topK);

    // Validate jsonString before sending
    const jsonString = JSON.stringify({
      queryVector: queryVectorString,
      topK: topK
    });

    // Add validation and logging for jsonString
    if (!jsonString || jsonString === '{}' || jsonString === 'null') {
      console.error('Invalid jsonString for vector search:', jsonString);
      throw new Error("Failed to create valid request parameters for vector search");
    }

    console.log('Vector search request params:', jsonString.substring(0, 100) + '...');

    const _response = await amplifyClient.queries.vectorSearch({
      queryStringParameters: jsonString,
    });

    console.log('Vector search raw response:', _response);

    // Add error handling for empty or invalid responses
    if (!_response || !_response.data || !_response.data.body) {
      console.error('Empty or invalid response from vector search');
      throw new Error("Empty or invalid response from vector search");
    }

    // Add try/catch around JSON parsing
    let response;
    try {
      // Check if the response body is valid before parsing
      if (typeof _response.data.body !== 'string' || _response.data.body.trim() === '') {
        console.error('Empty response body from vector search');
        throw new Error("Empty response body from vector search");
      }

      // Log the first part of the response for debugging
      console.log('Response body preview:', _response.data.body.substring(0, 100));

      response = JSON.parse(_response.data.body);
    } catch (parseError) {
      console.error('Failed to parse vector search response:', parseError);
      console.error('Response body type:', typeof _response.data.body);
      console.error('Response body preview:',
        typeof _response.data.body === 'string'
          ? _response.data.body.substring(0, 200)
          : 'Not a string');

      // Provide a fallback response instead of throwing
      return [{
        chunk: "Error parsing search results. Please try again later.",
        meta: { source: "system", title: "Search Error" }
      }];
    }

    // If all fields are null, it likely means the database is empty or not properly set up
    if (!response || response.chunks === null || response.metadata === null || response.error !== null) {
      console.log('Vector search returned all null fields - database may be empty or not properly set up');
      console.log('Response:', response);
      console.log('Data:', response.data);
      throw new Error("Vector database is empty or not properly configured");
      // For now, let's provide a default response to avoid breaking the application flow
      return [{
        chunk: "The vector database appears to be empty or not properly configured. Please check your database setup.",
        meta: { source: "system", title: "Database Configuration Issue" }
      }];
    }

    // Parse the metadata string back to an object
    const chunks = response?.chunks || [];
    const metadata = response?.metadata ? JSON.parse(response.metadata) : [];

    console.log(`Found ${chunks.length} matching chunks`);

    if (chunks.length === 0) {
      console.error('No matching chunks found in vector database - check if database is populated');
      throw new Error("No matching chunks found in vector database - check if database is populated");
    }

    // Return in the same format as fetchTopChunks
    return chunks.map((chunk: string, index: number) => ({
      chunk,
      meta: metadata[index] || {}
    }));
  } catch (error) {
    console.error("Error in vector search:", error);
    throw new Error(`Failed to perform vector search: ${error}`);
  }
}


// Normalize whatever the caller passes into a number[]
function toEmbeddingVector(qv: unknown): number[] {
  if (Array.isArray(qv)) return qv as number[];
  if (qv && typeof qv === 'object' && 'embedding' in (qv as any)) return (qv as any).embedding as number[];
  if (typeof qv === 'string') {
    const parsed = JSON.parse(qv);
    if (Array.isArray(parsed)) return parsed as number[];
    if (parsed?.embedding && Array.isArray(parsed.embedding)) return parsed.embedding as number[];
  }
  throw new Error('Invalid query vector: expected number[] or { embedding:number[] } or JSON string of either.');
}

export async function fetchTopChunksByDocType(
  queryVector: unknown,
  docType: 'suptamins_product' | 'suptamins_article' | 'suptamins_score',
  topK = 3,
): Promise<KBRow[]> {
  try {
    const embeddingVector = toEmbeddingVector(queryVector);
    if (!embeddingVector.length) throw new Error('Embedding vector is empty');

    const payload = {
      action: 'search',
      queryVector: JSON.stringify(embeddingVector),
      topK,
      docType,
    };

    const res = await amplifyClient.queries.vectorSearch({
      queryStringParameters: JSON.stringify(payload),
    });

    const body = typeof res?.data?.body === 'string' ? JSON.parse(res.data.body) : res?.data?.body;
    if (!body) throw new Error('Empty response body from vectorSearch');

    if (body.error) {
      console.warn(`vectorSearch error (${docType}):`, body.error);
      return [];
    }

    // Preferred: structured results from Lambda
    if (Array.isArray(body.results)) {
      return body.results as KBRow[];
    }

    // Legacy fallback (chunks + metadata string)
    const chunks: string[] = body.chunks ?? [];
    const metas: any[] = body.metadata ? JSON.parse(body.metadata) : [];
    return chunks.map((chunk, i) => ({
      chunk,
      doc_type: docType,
      title: metas[i]?.title,
      suptamins_score: metas[i]?.suptamins_score ?? null,
      meta: metas[i] ?? {},
    }));
  } catch (err) {
    console.error(`fetchTopChunksByDocType(${docType}) failed:`, err);
    return [];
  }
}


/**
 * Convert the raw JSON-ish chunk that lives in the `chunks` column
 * into the human-readable text we want Claude to see.
 *
 * 1. If it parses as JSON and has a `text` field → return that.
 * 2. Otherwise, grab everything up to the first curly-brace mess.
 */
export function cleanChunk(raw: string): string {
  const trimmed = (raw ?? "").trim();

  // If it's empty, return early
  if (!trimmed || trimmed === "undefined" || trimmed === "null") {
    console.warn("Empty or null chunk received");
    return "No content available";
  }

  // Check for plain text content that's clearly not JSON
  if (!trimmed.startsWith("{") && !trimmed.startsWith("[")) {
    // This is likely already plain text, just return it directly
    console.log("Received plain text chunk, skipping JSON parsing");
    return trimmed;
  }

  // Try to parse as JSON if it looks like JSON
  try {
    const maybeObj = JSON.parse(trimmed);
    if (maybeObj && typeof maybeObj.text === "string") {
      return maybeObj.text.trim();
    }
    // If it parsed as JSON but doesn't have a text field,
    // convert it back to a string representation
    return JSON.stringify(maybeObj);
  } catch (error) {
    console.error("Failed to parse chunk as JSON:", error);
    console.error("Raw chunk (first 100 chars):", trimmed.substring(0, 100));
    // If it failed to parse as JSON, just return the raw text
    return trimmed;
  }
}

export async function getRecordById(recordId: string, tableName: string = "SuptaminsKnowledgeBase") {
  try {
    // Validate inputs
    if (!recordId) {
      throw new Error("Record ID is required");
    }

    const jsonString = JSON.stringify({
      recordId,
      tableName
    });

    const response = await amplifyClient.queries.getRecordFromDynamoDB({
      queryStringParameters: jsonString,
    });

    console.log('DynamoDB response:', response);

    // Check if we have a response
    if (!response || !response.data) {
      console.error('Invalid response from DynamoDB:', response);
      throw new Error("Invalid response from DynamoDB");
    }

    // Parse the body from the response
    if (response.data.body) {
      try {
        const parsedBody = JSON.parse(response.data.body);

        // Check for errors
        if (parsedBody.error) {
          console.error('Error in DynamoDB response:', parsedBody.error);
          throw new Error(parsedBody.error);
        }

        // Parse the record if it exists
        if (parsedBody.record) {
          try {
            const parsedRecord = JSON.parse(parsedBody.record);
            console.log('Successfully parsed record:', parsedRecord);
            return parsedRecord;
          } catch (parseError) {
            console.error('Failed to parse record JSON:', parseError);
            throw new Error(`Failed to parse record: ${parseError}`);
          }
        } else {
          console.log('No record found in response body');
          return null;
        }
      } catch (parseError) {
        console.error('Failed to parse response body:', parseError);
        throw new Error(`Failed to parse response body: ${parseError}`);
      }
    } else {
      console.error('No body in response:', response);
      return null;
    }
  } catch (error) {
    console.error("Error getting record from DynamoDB:", error);
    throw new Error(`Failed to get record from DynamoDB: ${error}`);
  }
}

// 1) Backfill doc_type in KB (one-time admin action)
export async function backfillDocType(dryRun: boolean) {
  try {
    const payload = {
      action: "backfillDocType",
      dryRun: dryRun  // Pass the actual parameter value
    };

    const response = await amplifyClient.queries.vectorSearch({
      queryStringParameters: JSON.stringify(payload),
    });

    console.log("Backfill response:", response);
    return response.data?.body || "No response";
  } catch (err) {
    console.error("Backfill error:", err);
    return `Error: ${err}`;
  }
}

// 2) Test vector search (no explicit dimension cast; non-zero dummy vector)
export async function testDatabaseContents() {
  try {
    // create a non-zero dummy vector (small random noise)
    // const v = Array.from({ length: 1024 }, () => Math.random() * 1e-3);
    const v = [
      0.010299988090991974,
      0.04760567843914032,
      -0.011623892933130264,
      0.0018422515131533146,
      0.0334356315433979,
      0.005968458950519562,
      0.033538900315761566,
      0.018225664272904396,
      -0.052856117486953735,
      -0.02385447360575199,
      -0.05442608520388603,
      0.019103627651929855,
      -0.019701238721609116,
      0.023496268317103386,
      0.028036750853061676,
      0.016407614573836327,
      -0.0034594149328768253,
      -0.0328676700592041,
      -0.033330753445625305,
      -0.004049967974424362,
      0.026321565732359886,
      0.03321296349167824,
      -0.0113786356523633,
      0.014525831677019596,
      -0.03879014402627945,
      -0.00902610458433628,
      -0.010526690632104874,
      -0.028645053505897522,
      0.029747096821665764,
      -0.040573906153440475,
      0.029721280559897423,
      0.020937204360961914,
      -0.008390371687710285,
      -0.0449465811252594,
      -0.013424595817923546,
      0.02864343859255314,
      0.01856853999197483,
      0.03529200330376625,
      0.014987302012741566,
      0.009774783626198769,
      0.025789905339479446,
      -0.022829072549939156,
      -0.00281077460385859,
      0.0402027927339077,
      0.014092598110437393,
      -0.019143762066960335,
      -0.0013210802571848035,
      -0.08181258291006088,
      -0.007835316471755505,
      -0.0037046722136437893,
      0.0276107769459486,
      0.0334162712097168,
      0.022453926503658295,
      0.08932842314243317,
      -0.00669293524697423,
      0.045237015932798386,
      -0.013400392606854439,
      0.002216994296759367,
      0.03173496946692467,
      -0.01816515624523163,
      -0.049474555999040604,
      -0.004401718266308308,
      0.0644921138882637,
      0.010497646406292915,
      0.04174855351448059,
      -0.042745716869831085,
      0.06081729009747505,
      0.049222443252801895,
      -0.026468398049473763,
      -0.053901687264442444,
      0.05024057999253273,
      -0.014070008881390095,
      -0.03909268230199814,
      0.02819971740245819,
      -0.04308375343680382,
      0.06638075411319733,
      -0.03834399953484535,
      -0.031709153205156326,
      -0.0026574889197945595,
      0.006354093085974455,
      0.035233110189437866,
      -0.0189654678106308,
      0.06217265501618385,
      -0.01152062602341175,
      0.006850254721939564,
      -0.03746623918414116,
      -0.06871815025806427,
      -0.029989125207066536,
      0.056672122329473495,
      -0.0010487964609637856,
      -0.008261289447546005,
      0.003230293281376362,
      0.04546613618731499,
      -0.022021500393748283,
      0.05765799060463905,
      0.021379314363002777,
      -0.015238206833600998,
      0.06438158452510834,
      -0.041962552815675735,
      -0.00017849709547590464,
      -0.006269382778555155,
      0.028964532539248466,
      -0.02521790936589241,
      0.016303138807415962,
      0.0129558015614748,
      0.01797475852072239,
      0.0019330127397552133,
      -0.026553913950920105,
      0.015973977744579315,
      -0.04116445407271385,
      0.03160911425948143,
      0.10054893046617508,
      0.06832829117774963,
      -0.046936869621276855,
      0.005837762728333473,
      -0.014471778646111488,
      0.009216501377522945,
      -0.0004098374047316611,
      0.052973099052906036,
      0.026845963671803474,
      -0.07087282836437225,
      -0.04467550665140152,
      -0.0017797270556911826,
      -0.0016893690917640924,
      0.0011196911800652742,
      0.004766376689076424,
      0.008345193229615688,
      0.004216162022203207,
      -0.0016236177179962397,
      0.01195628009736538,
      0.05387869477272034,
      0.08920901268720627,
      0.015135747380554676,
      -0.046579472720623016,
      0.031399354338645935,
      -0.012569827027618885,
      -0.01737290993332863,
      0.01878798007965088,
      0.010189461521804333,
      0.013627899810671806,
      -0.06710360944271088,
      -0.06000084429979324,
      0.014450802467763424,
      0.016909826546907425,
      0.02594238519668579,
      -0.005986207630485296,
      -0.0243966206908226,
      -0.0016748474445194006,
      -0.01395696122199297,
      -0.03086245059967041,
      -0.00826290249824524,
      -0.002935823518782854,
      -0.0037821214646101,
      0.029973797500133514,
      0.026713654398918152,
      -0.002263786969706416,
      -0.03409557044506073,
      0.014615382999181747,
      0.020138101652264595,
      -0.02433086931705475,
      0.017413249239325523,
      0.0009828433394432068,
      -0.02025306597352028,
      -0.03044898249208927,
      -0.004290384240448475,
      -0.001571581233292818,
      0.015225297771394253,
      -0.046460069715976715,
      -0.028891922906041145,
      -0.007047912571579218,
      -0.000644606479909271,
      0.006041067652404308,
      0.00016682420391589403,
      0.003145582741126418,
      0.06041067838668823,
      0.000445335143012926,
      -0.009080157615244389,
      0.04295790195465088,
      -0.02221512421965599,
      -0.0017619781428948045,
      -0.04511161148548126,
      -0.014663788489997387,
      0.005857125390321016,
      0.03915076702833176,
      -0.014547614380717278,
      -0.04808490350842476,
      0.033127449452877045,
      -0.022216737270355225,
      0.016474172472953796,
      0.016964687034487724,
      0.010042630136013031,
      -0.04850925877690315,
      0.02609405666589737,
      -0.055960554629564285,
      -0.004634067416191101,
      0.010532337240874767,
      0.007822408340871334,
      -0.007218947168439627,
      0.029955241829156876,
      0.03902652487158775,
      0.03493460640311241,
      -0.010994615033268929,
      -0.02114373818039894,
      0.046321310102939606,
      0.008412961848080158,
      0.03826655447483063,
      0.00653319526463747,
      0.0015376971568912268,
      0.0322900228202343,
      -0.02191823348402977,
      0.03270309045910835,
      -0.030874956399202347,
      0.0682072713971138,
      -0.009629565291106701,
      0.04906431585550308,
      -0.014232168905436993,
      0.0012650099815800786,
      -0.013869930058717728,
      -0.02182142250239849,
      -0.03616572916507721,
      0.02966964803636074,
      -0.0017014705808833241,
      0.009335902519524097,
      0.03083784319460392,
      0.006042681634426117,
      0.0022605599369853735,
      0.052923884242773056,
      0.043926823884248734,
      0.05240432918071747,
      -0.01381991058588028,
      0.022137673571705818,
      -0.013525441288948059,
      0.03911849483847618,
      -0.06712297350168228,
      -0.01923331432044506,
      -0.04094662889838219,
      -0.0317414216697216,
      0.03691118583083153,
      0.006555784959346056,
      -0.017897307872772217,
      0.050835974514484406,
      -0.01063318271189928,
      -0.013695668429136276,
      -0.02351885847747326,
      -0.045266054570674896,
      0.07573682814836502,
      -0.026738664135336876,
      0.01353431586176157,
      0.008558180183172226,
      -0.02684919163584709,
      0.03440778702497482,
      -0.00941980630159378,
      0.0005585471517406404,
      -0.010636410675942898,
      0.0018265193793922663,
      0.006738114170730114,
      -0.009687652811408043,
      -0.008887340314686298,
      -0.00604590866714716,
      -0.04362348094582558,
      0.021072741597890854,
      0.07115156203508377,
      0.000004840599558519898,
      0.029376791790127754,
      -0.025682605803012848,
      -0.06480271369218826,
      -0.0031625248957425356,
      0.03205444663763046,
      -0.026524871587753296,
      -0.06118194758892059,
      -0.0015030060894787312,
      0.017259962856769562,
      0.06096210703253746,
      0.006609031930565834,
      0.039205629378557205,
      -0.059620048850774765,
      0.018011467531323433,
      -0.036536842584609985,
      -0.03691118583083153,
      0.008887340314686298,
      0.02085975743830204,
      0.033851925283670425,
      -0.01312185637652874,
      0.007642499636858702,
      0.008729365654289722,
      0.006301249843090773,
      0.0015506052877753973,
      -0.038176193833351135,
      -0.003391646547242999,
      0.0033561489544808865,
      -0.026534955948591232,
      -0.046121228486299515,
      -0.01310834288597107,
      -0.019201043993234634,
      0.011331843212246895,
      -0.06392333656549454,
      -0.010111205279827118,
      0.041332267224788666,
      0.0038208465557545424,
      0.005905531346797943,
      -0.03877642750740051,
      -0.0578128919005394,
      -0.0010649318573996425,
      0.022679820656776428,
      0.0171615369617939,
      -0.02026274986565113,
      -0.03973789140582085,
      -0.031541746109724045,
      0.04380742460489273,
      0.06828472018241882,
      -0.02939857356250286,
      0.043441154062747955,
      -0.01557382196187973,
      0.02282503806054592,
      -0.015528642572462559,
      -0.0014925181167200208,
      0.006969656329602003,
      -0.047278936952352524,
      -0.004367430694401264,
      0.03189309313893318,
      -0.04666982963681221,
      0.002200052374973893,
      -0.001615146640688181,
      0.027520420029759407,
      -0.004328705836087465,
      -0.052343014627695084,
      -0.01443628128618002,
      0.025093665346503258,
      -0.019295435398817062,
      -0.0679648369550705,
      0.004824464209377766,
      0.03902813792228699,
      0.031847916543483734,
      -0.017897307872772217,
      -0.0208387803286314,
      0.05060524120926857,
      0.00854527112096548,
      -0.04949217662215233,
      0.03904346749186516,
      0.015565753914415836,
      -0.07613939791917801,
      -0.003407781943678856,
      0.03522181138396263,
      -0.0023912559263408184,
      -0.019820641726255417,
      0.00616369629278779,
      0.06555462628602982,
      -0.03674983233213425,
      0.016591962426900864,
      -0.044875580817461014,
      -0.0001710345095489174,
      0.036320630460977554,
      -0.025093665346503258,
      0.006776839029043913,
      0.034524768590927124,
      0.054944027215242386,
      -0.002036278834566474,
      0.0345618799328804,
      -0.027885885909199715,
      -0.014779963530600071,
      -0.01121728215366602,
      0.036643337458372116,
      0.01203695684671402,
      0.05278431624174118,
      -0.03569135069847107,
      0.03488458693027496,
      0.046511705964803696,
      0.031034696847200394,
      0.008516227826476097,
      0.038637664169073105,
      0.027674512937664986,
      0.018865428864955902,
      -0.05777093768119812,
      -0.02359630912542343,
      0.0019307939801365137,
      0.004701835568994284,
      0.022119926288723946,
      -0.03907331824302673,
      -0.01613210327923298,
      -0.04069007933139801,
      -0.027349386364221573,
      -0.06434769928455353,
      -0.02860148809850216,
      0.01994004286825657,
      0.024157816544175148,
      0.008199975825846195,
      -0.005821627099066973,
      0.006349253002554178,
      -0.06664860248565674,
      -0.0349007211625576,
      0.019549567252397537,
      0.05066493898630142,
      0.0048986864276230335,
      0.0016966300318017602,
      0.03796643391251564,
      -0.0036724014207720757,
      -0.02799157239496708,
      0.023360732942819595,
      -0.006842187140136957,
      -0.03361796215176582,
      0.03435212001204491,
      0.021714121103286743,
      -0.03261757269501686,
      -0.000038724796468159184,
      0.03460706025362015,
      -0.008137451484799385,
      0.030710376799106598,
      -0.005949096754193306,
      -0.032134320586919785,
      -0.016338635236024857,
      0.030135957524180412,
      0.0038845809176564217,
      -0.022010205313563347,
      -0.00989418476819992,
      -0.0024590243119746447,
      0.03642752766609192,
      0.006194353569298983,
      0.041090235114097595,
      -0.0036691741552203894,
      -0.0327531099319458,
      0.0011277588782832026,
      0.0222990270704031,
      -0.0004824463976547122,
      -0.03312906250357628,
      0.02025306597352028,
      0.01785631664097309,
      -0.02971159853041172,
      0.0046865069307386875,
      0.0024525702465325594,
      0.01798766851425171,
      -0.009284269995987415,
      -0.0009329751483164728,
      -0.0033900332637131214,
      -0.008083800785243511,
      -0.032035086303949356,
      0.003102672751992941,
      0.016422539949417114,
      0.03078782558441162,
      -0.009045465849339962,
      0.032619185745716095,
      0.05779675766825676,
      0.05729333311319351,
      -0.014202318154275417,
      -0.042894162237644196,
      0.024119094014167786,
      0.0004033832810819149,
      -0.03247719630599022,
      0.03953640162944794,
      -0.029972990974783897,
      -0.03601083159446716,
      0.007920430973172188,
      0.015673860907554626,
      0.00048728700494393706,
      -0.06393786519765854,
      -0.023338142782449722,
      -0.03497857227921486,
      -0.016726691275835037,
      0.010233833454549313,
      0.03008553385734558,
      0.07803045958280563,
      -0.009802213869988918,
      0.014818688854575157,
      -0.030857207253575325,
      0.03632385656237602,
      0.0013647464802488685,
      0.030979836359620094,
      0.00954888854175806,
      -0.035431571304798126,
      -0.005328289698809385,
      0.05391782522201538,
      0.0278302188962698,
      0.022105403244495392,
      -0.017671413719654083,
      0.030718443915247917,
      0.00939640961587429,
      -0.03394228219985962,
      0.01096557080745697,
      -0.013689215295016766,
      -0.0247354619204998,
      0.027804400771856308,
      0.03543722257018089,
      0.006976916920393705,
      -0.03738556057214737,
      -0.002321067498996854,
      0.003056535730138421,
      0.05702225863933563,
      -0.016519350931048393,
      -0.0016950166318565607,
      0.023981943726539612,
      0.01978352852165699,
      -0.012103111483156681,
      0.01845216378569603,
      0.004401718266308308,
      0.0027042815927416086,
      -0.020111076533794403,
      0.042080942541360855,
      0.0345618799328804,
      -0.0030350559391081333,
      -0.01547862309962511,
      0.004253273364156485,
      -0.08237691223621368,
      0.0028131951112300158,
      -0.023593081161379814,
      -0.06340216845273972,
      0.005770397838205099,
      -0.006913989316672087,
      -0.049399930983781815,
      -0.05874874070286751,
      -0.03688536584377289,
      0.03782283142209053,
      0.04846730828285217,
      0.038379501551389694,
      0.024202996864914894,
      0.04948342964053154,
      -0.027781005948781967,
      -0.002173429122194648,
      0.013524634763598442,
      -0.0014134550001472235,
      0.0015231752768158913,
      -0.05776771157979965,
      0.046918317675590515,
      -0.038595713675022125,
      0.005718361120671034,
      0.011965961195528507,
      -0.005382746458053589,
      -0.05557653307914734,
      0.006593299563974142,
      -0.014331401325762272,
      -0.034261759370565414,
      -0.00731575908139348,
      0.006900476291775703,
      -0.03982199728488922,
      -0.0061185178346931934,
      0.021737517789006233,
      0.004206480924040079,
      -0.05839376151561737,
      0.026474852114915848,
      -0.02610696479678154,
      0.013724712654948235,
      -0.04017697274684906,
      0.03210285305976868,
      0.01610306091606617,
      0.0014715421712026,
      0.011256006546318531,
      0.01466701552271843,
      0.013191440142691135,
      -0.052000947296619415,
      0.0028462721966207027,
      0.009172935970127583,
      0.004099987912923098,
      -0.048205915838479996,
      0.01858709380030632,
      0.04257791116833687,
      -0.04197908937931061,
      0.026736242696642876,
      0.024270763620734215,
      -0.0042919982224702835,
      -0.021518077701330185,
      0.012209605425596237,
      0.030779756605625153,
      0.013063163496553898,
      -0.0729413777589798,
      -0.04056422412395477,
      0.06716977059841156,
      0.021730661392211914,
      -0.02501702308654785,
      0.0001054847234627232,
      -0.061564356088638306,
      -0.025409920141100883,
      -0.0018378142267465591,
      0.011422201059758663,
      0.04414061829447746,
      0.0007147951400838792,
      0.042258430272340775,
      -0.03653039038181305,
      0.0207242202013731,
      -0.021831506863236427,
      0.05724170058965683,
      0.008090254850685596,
      0.04253918677568436,
      -0.020561253651976585,
      0.032444924116134644,
      0.027472013607621193,
      0.010726767592132092,
      0.00501889456063509,
      -0.017719820141792297,
      0.06544490158557892,
      0.03493541106581688,
      -0.03998980298638344,
      -0.05546358600258827,
      -0.008061211556196213,
      0.03040218912065029,
      0.04407527297735214,
      -0.013571426272392273,
      -0.004711516667157412,
      -0.02040151320397854,
      0.037282299250364304,
      0.009132597595453262,
      -0.008049916476011276,
      -0.010003904812037945,
      0.01770852506160736,
      -0.02813194878399372,
      0.044627100229263306,
      -0.0037022517062723637,
      0.06103673204779625,
      0.019927537068724632,
      -0.018395891413092613,
      -0.015399560332298279,
      -0.0437009297311306,
      -0.04164528846740723,
      -0.003988653887063265,
      -0.013314875774085522,
      -0.03677564486861229,
      0.0024800002574920654,
      -0.020545924082398415,
      0.03965902701020241,
      0.0056029935367405415,
      0.03491362929344177,
      0.017626235261559486,
      -0.0026994410436600447,
      -0.006521901115775108,
      -0.0012779181124642491,
      -0.04349439963698387,
      -0.001912641804665327,
      0.016837218776345253,
      0.011312480084598064,
      -0.008406507782638073,
      -0.027070244774222374,
      0.0484447181224823,
      0.0034448932856321335,
      -0.02124055102467537,
      -0.007167314179241657,
      0.03366152569651604,
      0.04609864205121994,
      0.025051714852452278,
      0.026647498831152916,
      0.03370993211865425,
      -0.0036820825189352036,
      0.03509111702442169,
      0.02826264500617981,
      -0.020743580535054207,
      -0.020892027765512466,
      -0.013500431552529335,
      -0.0035860773641616106,
      -0.0004542095703072846,
      -0.002322277519851923,
      -0.018914641812443733,
      0.010975655168294907,
      -0.02731388993561268,
      0.05513523519039154,
      0.01768754981458187,
      -0.0033960838336497545,
      0.06807173043489456,
      -0.028840290382504463,
      -0.06610645353794098,
      0.006012024357914925,
      0.017629463225603104,
      -0.009372206404805183,
      -0.023113761097192764,
      0.01839427649974823,
      0.035397689789533615,
      0.05152656510472298,
      0.005182668566703796,
      -0.0009729604353196919,
      0.03957673907279968,
      -0.01758347637951374,
      0.04148555174469948,
      0.05271735414862633,
      -0.0353492833673954,
      -0.02098238468170166,
      0.011690047569572926,
      0.05975881218910217,
      -0.003050384344533086,
      0.00393460039049387,
      -0.01010555773973465,
      -0.01972625032067299,
      -0.008028941228985786,
      -0.04106764495372772,
      0.003811165224760771,
      -0.028901604935526848,
      0.002013689372688532,
      -0.043991364538669586,
      -0.017844868823885918,
      0.016340147703886032,
      0.012540379539132118,
      -0.038468245416879654,
      0.006240339484065771,
      0.0005526351160369813,
      -0.03702090308070183,
      -0.026923412457108498,
      0.0029253356624394655,
      0.044210806488990784,
      -0.0037885757628828287,
      0.07619426399469376,
      0.0181853249669075,
      0.01709054224193096,
      -0.011990164406597614,
      -0.011768302880227566,
      0.01597125455737114,
      -0.04638262465596199,
      0.005998511333018541,
      0.0235446747392416,
      -0.0020432875026017427,
      -0.023349840193986893,
      0.04030928388237953,
      -0.06800880283117294,
      0.020441044121980667,
      0.004812362603843212,
      0.009729200974106789,
      -0.026451051235198975,
      -0.016274094581604004,
      0.033682502806186676,
      0.03580893948674202,
      0.07705427706241608,
      0.01629023067653179,
      0.051403939723968506,
      0.0295244287699461,
      -0.051649194210767746,
      0.04104828089475632,
      0.019117141142487526,
      0.018255513161420822,
      -0.028998415917158127,
      0.04221809282898903,
      0.03779217228293419,
      0.010406380519270897,
      -0.0022557193879038095,
      0.003837788477540016,
      -0.02481936477124691,
      -0.010244322009384632,
      -0.019454367458820343,
      -0.006780066527426243,
      -0.043256402015686035,
      0.030075449496507645,
      0.007181028835475445,
      -0.00685832230374217,
      0.005492466501891613,
      0.020582227036356926,
      -0.0020943661220371723,
      0.0070511396043002605,
      -0.039273396134376526,
      -0.018316827714443207,
      0.028685392811894417,
      0.02952120080590248,
      -0.03893616795539856,
      -0.01673395186662674,
      -0.02243456430733204,
      0.029329190030694008,
      0.023375254124403,
      -0.008262500166893005,
      -0.05491821467876434,
      0.07416846603155136,
      0.0035045938566327095,
      0.04392198473215103,
      -0.020269202068448067,
      -0.05978664383292198,
      -0.0037149584386497736,
      0.006741341203451157,
      0.015610932372510433,
      -0.05149752274155617,
      0.055571287870407104,
      -0.008354874327778816,
      0.010471023619174957,
      -0.01619987189769745,
      -0.01652580499649048,
      0.011972415260970592,
      -0.01623375527560711,
      -0.03925322741270065,
      -0.016086118295788765,
      -0.02753816917538643,
      0.034843847155570984,
      0.03422626480460167,
      -0.030563542619347572,
      0.014153912663459778,
      -0.07163441926240921,
      0.011995005421340466,
      -0.02492585964500904,
      -0.023314746096730232,
      0.006665505468845367,
      -0.0035110481549054384,
      -0.03383579105138779,
      -0.004817202687263489,
      0.009813508950173855,
      -0.02672978863120079,
      0.055728208273649216,
      -0.011762656271457672,
      -0.0014812233857810497,
      0.005850671324878931,
      -0.01723656803369522,
      -0.024377258494496346,
      0.013495591469109058,
      -0.015568980947136879,
      0.02057577297091484,
      0.021243777126073837,
      0.06310850381851196,
      0.000203305171453394,
      -0.07008219510316849,
      -0.011667861603200436,
      -0.01540601346641779,
      0.0010149123845621943,
      -0.012430659495294094,
      -0.01760687306523323,
      0.02630704455077648,
      0.021789152175188065,
      0.024375643581151962,
      0.03780508041381836,
      0.0004792193358298391,
      0.08058952540159225,
      -0.057941973209381104,
      -0.06849286705255508,
      -0.010922812856733799,
      -0.020627407357096672,
      0.04503794386982918,
      0.006820404436439276,
      -0.014456450007855892,
      -0.006076565943658352,
      0.05795891582965851,
      0.013982877135276794,
      0.03786800801753998,
      -0.05492789298295975,
      0.002988263266161084,
      -0.08356457948684692,
      -0.011673912405967712,
      0.0016746456967666745,
      0.059920165687799454,
      0.06149497255682945,
      0.06681317836046219,
      -0.02592463605105877,
      -0.06519964337348938,
      0.054279252886772156,
      0.027970192953944206,
      -0.047244250774383545,
      0.0020282110199332237,
      0.03717903047800064,
      -0.05523769184947014,
      0.033877741545438766,
      0.06478980928659439,
      0.02754301019012928,
      0.000822095142211765,
      0.012075682170689106,
      0.03957512602210045,
      0.0006905921618454158,
      -0.020480576902627945,
      -0.003678855486214161,
      -0.020111076533794403,
      -0.005923280026763678,
      -0.008509773761034012,
      -0.012959898449480534,
      -0.0113475751131773,
      -0.023927083238959312,
      0.005324659403413534,
      0.015983885154128075,
      -0.013630321249365807,
      -0.04142584651708603,
      -0.029311442747712135,
      0.017817843705415726,
      -0.02315904200077057,
      0.004066103603690863,
      -0.013460093177855015,
      -0.07934226095676422,
      -0.041145093739032745,
      0.0075642429292202,
      -0.005615095142275095,
      0.00011456084757810459,
      0.008703397586941719,
      0.03533637523651123,
      -0.032030243426561356,
      -0.009098713286221027,
      0.013279377482831478,
      -0.03851665183901787,
      0.02653455175459385,
      0.0219053253531456,
      -0.01819339394569397,
      0.019389020279049873,
      -0.006433156784623861,
      0.0022654004860669374,
      -0.016232142224907875,
      0.06814595311880112,
      -0.02001023106276989,
      -0.030305378139019012,
      0.03167849779129028,
      -0.018578220158815384,
      -0.02599724382162094,
      0.014478232711553574,
      -0.04068846255540848,
      -0.04329916089773178,
      -0.0373726524412632,
      -0.011272141709923744,
      0.00019846457871608436,
      -0.0981350839138031,
      -0.01626558043062687,
      -0.0024582177866250277,
      -0.015500405803322792,
      -0.018200652673840523,
      -0.02180851250886917,
      -0.015247081406414509,
      0.02784312702715397,
      -0.012969578616321087,
      0.014915096573531628,
      -0.017487874254584312,
      -0.03696362301707268,
      -0.04117736592888832,
      0.021453535184264183,
      0.026855645701289177,
      0.0008196748094633222,
      0.011449630372226238,
      0.012353208847343922,
      0.008177385665476322,
      0.05190574377775192,
      -0.005579597316682339,
      -0.05520864948630333,
      -0.011096267029643059,
      -0.008319376036524773,
      -0.03407781943678856,
      0.0028684583958238363,
      -0.06152724474668503,
      0.0221893060952425,
      0.0036982179153710604,
      -0.006015251390635967,
      -0.010171309113502502,
      -0.0032626648899167776,
      -0.012508109211921692,
      -0.01600624807178974,
      -0.04815750941634178,
      -0.012141836807131767,
      -0.0276656374335289,
      -0.022641096264123917,
      0.016089346259832382,
      -0.00806605163961649,
      -0.0024842359125614166,
      -0.0169921163469553,
      -0.022050542756915092,
      -0.024825820699334145,
      -0.0032238392159342766,
      -0.002824489725753665,
      -0.024914564564824104,
      -0.025216296315193176,
      0.007207450922578573,
      0.038608621805906296,
      0.005221393425017595,
      -0.0138602489605546,
      -0.01707763411104679,
      0.03145098686218262,
      -0.015151076018810272,
      -0.02346399798989296,
      0.03983006626367569,
      -0.017266416922211647,
      0.017881173640489578,
      0.012184595689177513,
      0.0650576576590538,
      -0.030916906893253326,
      -0.01204341184347868,
      -0.024041643366217613,
      0.01598365791141987,
      -0.004155856091529131,
      -0.003607860067859292,
      0.015728721395134926,
      0.03882160782814026,
      -0.005673989187926054,
      0.012236934155225754,
      0.012621056288480759,
      -0.0026978272944688797,
      -0.027052495628595352,
      -0.04859316349029541,
      0.0000637345583527349,
      -0.013079702854156494,
      -0.02267659455537796,
      -0.044189829379320145,
      0.0822191908955574,
      0.03337270766496658,
      0.04931844770908356,
      0.008509370498359203,
      0.029668033123016357,
      0.044656142592430115,
      -0.006315469276160002,
      0.011498036794364452,
      0.01755524054169655,
      0.044126905500888824,
      0.02054188959300518,
      -0.035588089376688004,
      0.0331919901072979,
      -0.023744752630591393,
      0.025751987472176552,
      -0.02492908574640751,
      -0.04321686923503876,
      -0.01579689234495163,
      0.03159943222999573,
      -0.013928924687206745,
      0.05871646851301193,
      -0.026097284629940987,
      -0.06450260430574417,
      0.02296380326151848,
      -0.03194472938776016,
      -0.019133277237415314,
      0.0020975929219275713,
      0.021157048642635345,
      0.06132877990603447,
      0.01769077777862549,
      0.08621753007173538,
      0.022417621687054634,
      -0.008919610641896725,
      0.013621446676552296,
      -0.09555988013744354,
      0.029692236334085464,
      -0.017326723784208298,
      -0.000564736605156213,
      -0.0319705456495285,
      -0.007919220253825188,
      0.044356025755405426,
      -0.013385063968598843,
      0.031075438484549522,
      -0.0027188032399863005,
      -0.003643609816208482,
      -0.00800312403589487,
      -0.038952603936195374,
      0.04009388014674187,
      -0.009132597595453262,
      0.02499685436487198,
      0.001974964514374733,
      -0.009913547895848751,
      -0.00813866127282381,
      -0.015322109684348106,
      0.035955969244241714,
      -0.0024202996864914894,
      0.03755014017224312
    ];
    const payload = {
      action: "search",
      queryVector: JSON.stringify(v),   // keep as string; Lambda casts with ::vector
      topK: 1,
      // Optional: omit docType while data stabilizes (or pass "")
      // docType: ""
    };

    const response = await amplifyClient.queries.vectorSearch({
      queryStringParameters: JSON.stringify(payload),
    });

    const body = typeof response.data?.body === 'string' ? JSON.parse(response.data.body) : response.data?.body;
    const results = body?.results;

    if (results?.length) {
      const r = results[0];
      if (r.distance != null && r.distance > 0.8) {
        return "Error: No match";
      }
      console.log("Top match", {
        title: r.title,
        score: r.suptamins_score,
        distance: r.distance.toFixed(6),
        source: r.source_url,
        preview: r.chunk.slice(0, 240) + (r.chunk.length > 240 ? "…" : "")
      });
    }

    console.log("Database test response:", response);
    return body || "No response";
  } catch (error) {
    console.error("Database test error:", error);
    return `Error: ${error}`;
  }
}

